export default "__VITE_ASSET__DlCgtYmq__"